// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","413":"092bb3d6","703":"38afca75","945":"2f05b61e"}[chunkId] + ".chunk.js";
};